import { Box } from "@mui/material";

const DownloadButtonContainer = ({ children }) => {
  return <Box sx={{ position: "absolute", top: "5px", right: "5px" }}>{children}</Box>;
};

export default DownloadButtonContainer;
